export function PageNotFound(props) {
  return <h1>Aouch ! Page not found</h1>;
}
